import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Label, Row } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { loadBankAccount, saveBankAccount } from '../../../../../actions';
import { convertStringToBoolean, localizeArea, localizeCountryNames, localizeCurrency } from '../../../../../utils/CommonUtils';
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { areaList, countryList, currencyList } from '../../../../../utils/Constants';

class BankAccount extends Component {

    constructor(props) {
        super(props);

        this.state = {
            bankCountry: '',
            bankCurrency: '',
            bankAddress: '',
            bankNumber: '',
            area: 'EU',
            iban: '',
            bic: '',
            accountNumber: '',
            type: 'COMPANY'
        };
    }

    componentDidMount() {
        const restaurantId = this.props.match.params.id;

        this.props.loadBankAccount(restaurantId)
        
    }

    componentDidUpdate(prevProps) {
        const { bankAccount } = this.props.restaurant;

        if(bankAccount !== prevProps.restaurant.bankAccount) {
            
            this.setState({
                bankCountry: bankAccount.bankCountry ? bankAccount.bankCountry : '',
                bankCurrency: bankAccount.bankCurrency ? bankAccount.bankCurrency : '',
                bankAddress: bankAccount.bankAddress ? bankAccount.bankAddress : '',
                bankNumber: bankAccount.bankNumber ? bankAccount.bankNumber : '',
                area: bankAccount.area ? bankAccount.area : 'EU',
                iban: bankAccount.iban ? bankAccount.iban : '',
                bic: bankAccount.bic ? bankAccount.bic : '',
                accountNumber: bankAccount.accountNumber ? bankAccount.accountNumber : '',
                routingNumber: bankAccount.routingNumber ? bankAccount.routingNumber : '',
                // type: bankAccount.type ? bankAccount.type : ''
            })
        }
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    changeState = ({ target }) => {

        this.setState({
            ...this.state,
            [target.name]: target.value
        });
    }

    changeBooleanAttributeState = ({ target }) => {
        const checked = convertStringToBoolean(target.checked);

        this.setState({
            [target.name]: checked
        });
    }

    saveBankAccount(state, restaurantId) {

        this.props.saveBankAccount(state, restaurantId, () => {
            this.props.loadBankAccount(restaurantId)
        })
    }

    renderCountryOptions() {
        return countryList.map((country, i) => {
            return <option key={i} value={country}>{localizeCountryNames(country)}</option>
        });
    }

    renderBankCountry() {
        const { bankCountry } = this.state;
        
        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3} for="bankCountry" >{i18n.t('screens:paymentScreen.bankCountry')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput 
                        type="select" 
                        name="bankCountry" 
                        id="bankCountry" 
                        placeholder={i18n.t('screens:paymentScreen.bankCountry')}
                        value={bankCountry}
                        onChange={this.changeState}
                        required
                        disabled={this.props.isMenuuAdmin}
                    >
                        <option value="">{i18n.t('common:validations.chooseCountry')}</option>
                        {this.renderCountryOptions()}
                    </AvInput>
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        );
    }

    renderCurrencyOptions() {
        
        return currencyList.map((currency, i) => {
            return <option key={i} value={currency}>{localizeCurrency(currency)}</option>
        })
    }

    renderBankCurrency() {
        const { bankCurrency } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3} for="bankCurrency" >{i18n.t('screens:paymentScreen.bankCurrency')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput 
                        type="select" 
                        name="bankCurrency" 
                        id="bankCurrency" 
                        placeholder={i18n.t('screens:paymentScreen.bankCurrency')}
                        value={bankCurrency}
                        onChange={this.changeState}
                        required
                        disabled={this.props.isMenuuAdmin}
                    >
                        <option value="">{i18n.t('screens:paymentScreen.chooseCurrency')}</option>
                        {this.renderCurrencyOptions()}
                    </AvInput>
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        );
    }

    renderAreaOptions() {
        
        return areaList.map((area, i) => {
            return <option key={i} value={area}>{localizeArea(area)}</option>
        })
    }

    renderArea() {
        const { area } = this.state;
        
        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3} for="area" >{i18n.t('screens:paymentScreen.area')}</Label>
                <AvInput 
                    type="select"
                    name="area" 
                    id="area" 
                    placeholder={i18n.t('screens:paymentScreen.area')}
                    value={area}
                    onChange={this.changeState}
                    required
                    disabled={this.props.isMenuuAdmin}
                >
                    {/* <option value="">{i18n.t('screens:paymentScreen.chooseCurrency')}</option> */}
                    {this.renderAreaOptions()}
                </AvInput>
                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
            </AvGroup>
        );
    }

    renderSortCodeRoutingNumber() {
        const { bankNumber, area } = this.state;
        
        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{area === 'AU' ? i18n.t('screens:paymentScreen.bsb') : `${i18n.t('screens:paymentScreen.sortCode')} / ${i18n.t('screens:paymentScreen.routingNumber')}`}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="bankNumber"
                        placeholder={bankNumber}
                        value={bankNumber}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderIBAN() {
        const { iban } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.iban')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="iban"
                        placeholder={iban}
                        value={iban}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                 </div>
            </AvGroup>
        )
    }

    renderBIC() {
        const { bic } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.bic')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="bic"
                        placeholder={bic}
                        value={bic}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderBankAddress() {
        const { bankAddress } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.bankAddress')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="bankAddress"
                        placeholder={bankAddress}
                        value={bankAddress}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderAccountNumber() {
        const { accountNumber, area } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                {/* <Label xs={3}>{i18n.t('screens:paymentScreen.accountNumber')}</Label> */}
                <Label xs={3}>{area === 'MX' || area === 'AR' || area === 'CL' ? i18n.t('screens:paymentScreen.clabe') : `${i18n.t('screens:paymentScreen.accountNumber')}`}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="accountNumber"
                        placeholder={accountNumber}
                        value={accountNumber}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
         </AvGroup>
        )
    }

    renderType() {
        const { type } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.type')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="type"
                        placeholder={type}
                        value={type}
                        // onChange={this.changeState}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderSaveButton() {
        const { saveBtn } = this.props.styles;

        return (
            <Col xs={12} style={{display: 'flex', justifyContent: 'flex-end' }}>
                <Button disabled={this.props.isMenuuAdmin} color="primary" style={{ display: 'flex', alignItems: 'center' }}>
                    <span className="saveIcon" style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="save" color="#fff" size={18} /></span>
                    <span style={saveBtn}>{i18n.t('common:buttons.save')}</span>
                </Button>
            </Col>
        )
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = this.props.styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.bankAccount')}</span>
            </div>
        );
    }

    renderBody() {
        const { area } = this.state;
        const restaurantId = this.props.match.params.id;

        return (
            <Row xs={12}>
                <AvForm onValidSubmit={() => this.saveBankAccount(this.state, restaurantId)} style={{ padding: '0px 0px 5px 0px', width: '100%' }}>
                    <Col xs={8} style={{margin: '20px 30px'}}>
                        {this.renderBankCountry()}
                        {this.renderBankCurrency()}
                        {this.renderBankAddress()}
                        {this.renderArea()}
                        { area === "EU" ? this.renderIBAN() : null }   
                        { area === "EU" || area === "MX" || area === "AR" || area === "CL" ? this.renderBIC() : null }
                        { area !== "EU" && area !== "MX" && area !== "AR" && area !== "CL" ? this.renderSortCodeRoutingNumber() : null }
                        { area !== "EU" || area === "MX" && area === "AR" && area === "CL" ? this.renderAccountNumber() : null }
                        {this.renderType()}
                    </Col>
                    {this.renderSaveButton()}
                </AvForm>
            </Row>
        )
    }

    render() {

        return (
            <div>
                {this.renderHeader()}
                {this.renderBody()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    
    return {
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        restaurant: state.restaurant
    }
}

export default connect(mapStateToProps, {loadBankAccount, saveBankAccount})(BankAccount);

const styles = {

    cardContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '15px'
    },
    btnStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/BankAccount.js